import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { firebaseRoot } from './../../utils/firebase-utils';

import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';
import ChoiceBox from '../../components/ChoiceBox/ChoiceBox';
import MobileHeader from '../../components/MobileHeader/MobileHeader';

import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import Input from 'react-bootstrap/lib/Input';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';

const ProfilePaymentCancel = React.createClass({
	mixins: [LinkedStateMixin],

	contextTypes: {
		history: React.PropTypes.object.isRequired
	},

	render() {
		return (
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='profile'
					title='Oh, sorry you feel this way!'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content section-wrap">
					<div className="section-body">
						<div className="profile-payment-cancel-body">
							<p className="lead">Please tell me why so I can continue improving is understanding your needs.</p>
							<form>
								<div className="ma-form-section">
									<div className="ma-form-group">
										<ChoiceBox
											label="I've finished my studies and don't need more tutoring."
											type="radio"
										    name="reason"
										/>
									</div>
									<div className="ma-form-group">
										<ChoiceBox
											label="I'm changing book and my neew book is not yet available in Albert."
											type="radio"
											name="reason"
										/>
									</div>
									<div className="ma-form-group">
										<ChoiceBox
											label="I've become a mathematical genious and don't need Alberts help anymore."
											type="radio"
											name="reason"
										/>
									</div>
									<div className="ma-form-group">
										<ChoiceBox
											label="I don't want to disclose."
											type="radio"
											name="reason"
										/>
									</div>
									<div className="ma-form-group">
										<ChoiceBox
											label="Other"
											type="radio"
											name="reason"
										/>
									</div>
								</div>
							</form>
						</div>
					</div>
					<div className="section-footer">
						<TouchLink to="/profile/payment/card" className="profile-payment-cancel-link">I regret it, continue the tutoring.</TouchLink>
						<TouchButton bsStyle="primary" block>Confirm the cancellation</TouchButton>
					</div>
				</div>
			</div>
		);
	}
});

export default ProfilePaymentCancel;


/** WEBPACK FOOTER **
 ** ./src/screens/profile/ProfilePaymentCancel.js
 **/